import type { TourConfig } from '../types';

export const evidenceLibraryPageTour: TourConfig = {
  pageId: 'evidence-library',
  pageName: 'Evidence Library',
  portalId: 'crm',
  steps: [
    {
      element: '[data-tour="evidence-search"]',
      title: 'Search & Filter',
      intro:
        'Search visits by company name and filter by business to find specific evidence records.',
      platform: 'both',
      requiredRoles: ['owner', 'admin'],
    },
    {
      element: '[data-tour="evidence-cards"]',
      title: 'Visit Cards',
      intro:
        'Each card shows a visit with its date, visitor, notes, and evidence photos. Click thumbnails to view full-size images.',
      platform: 'both',
      requiredRoles: ['owner', 'admin'],
    },
  ],
};
